/**
 * Utility function to fix API path discrepancies between frontend and backend
 * 
 * The backend API uses 'warehouses' (without hyphen) while the frontend code
 * has been using 'ware-houses' (with hyphen). This utility ensures all API calls
 * use the correct path format.
 */

/**
 * Transforms API paths to ensure they use the correct format
 * @param {string} url - The original URL that might contain incorrect path format
 * @returns {string} - The corrected URL
 */
export const fixApiPath = (url) => {
  // Replace 'ware-houses' with 'warehouses' in the URL
  return url.replace(/ware-houses/g, 'warehouses');
};

/**
 * Creates a warehouse API URL with the correct path format
 * @param {string} baseUrl - The API base URL
 * @param {string} path - Additional path segments (optional)
 * @param {Object} params - Query parameters (optional)
 * @returns {string} - The complete warehouse API URL
 */
export const createWarehouseUrl = (baseUrl, path = '', params = null) => {
  let url = `${baseUrl}warehouses/${path}`;
  
  // Add query parameters if provided
  if (params) {
    const queryString = new URLSearchParams(params).toString();
    url += `?${queryString}`;
  }
  
  return url;
};
